import { httpRequest } from './httpClient'

export function createOrder({ totalFee, credits, orderType = 'RECHARGE' } = {}) {
  return httpRequest('/api/pay/create-order', {
    method: 'POST',
    body: { totalFee, credits, orderType }
  })
}

export function queryOrderStatus(outTradeNo) {
  return httpRequest(`/api/pay/status/${outTradeNo}`)
}

export function getSubscriptionStatus() {
  return httpRequest('/api/pay/subscription')
}

export function getPlans() {
  return httpRequest('/api/pay/plans')
}
